import { makeObservable } from 'mobx';
import { Common } from 'src/domains/common/Common';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';
import { BasicDataModel } from 'src/domains/players/state/BasicDataModel';
import { BBReferralLegType } from 'src/domains/sportsbook/betting/betSlipState/BetSlipTypes';
import { Amount } from 'src_common/common/amount/Amount';

export class BetSlipBBReferralState {
    public constructor(
        private readonly bbBet: BBReferralLegType,
        private readonly common: Common
    ) {
        makeObservable(this);
    }

    public isVisible = true;

    public toggleVisibility = (): void => {
        this.isVisible = !this.isVisible;
    };

    public get title(): string {
        return ConfigComponents.get(this.common).config.rabHeaderTitle;
    }

    public get eventName(): string | null {
        return this.common.models.getEvent(this.bbBet.internalEventId)?.name ?? null;
    }

    public get selections() {
        const names = this.bbBet.name.split(', ');

        return names.map((name) => {
            const [selectionName, marketName] = name.split(' | ');
            return {
                selectionName,
                marketName,
            };
        });
    }

    private amountToString(value: string): string {
        return BasicDataModel.get(this.common).money(new Amount(value));
    }

    private get price() {
        return this.bbBet.price ?? null;
    }

    private get potentialReturns() {
        return this.bbBet.potentialReturns ?? null;
    }

    private get stakePerLine(): string {
        return this.bbBet.stakePerLine;
    }

    public get stakeDisplay(): string {
        return this.amountToString(this.stakePerLine);
    }

    public get priceLabel(): string {
        return this.price !== null ? this.price.f : '';
    }

    public get potentialReturnsLabel(): string {
        const priceDecimal = this.price !== null ? this.price.d : 0;

        return this.amountToString(this.potentialReturns || `${priceDecimal * Number(this.stakePerLine)}`);
    }
}
